import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import 'ant-design-vue/dist/antd.css';
import './styles/index.scss';
import './styles/theme.scss';

createApp(App).use(router).mount('#app')
